<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Gestion de productos</h1>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-card-title>
                        <v-container flex grid-list-sm>
                            <v-layout wrap align-center justify-center>
                                <v-flex class="text-xs-center">
                                    <v-btn color="orange" dark @click.native="filtroDiag = true">
                                        <v-icon>filter_list</v-icon>
                                        Filtros
                                    </v-btn>
                                    <v-btn color="orange" dark @click.native="verificaBloqueados()">
                                        Valida Activos
                                    </v-btn>
                                    <v-btn color="orange" dark @click.native="actualizaAnchos()">
                                        Actualiza anchos
                                    </v-btn>
                                </v-flex>
                                <v-flex class="text-xs-center">
                                    <v-text-field v-model="search" label="Búsqueda" clearable prepend-icon="search"
                                                  @blur="getData()"></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :items="items"
                            :pagination.sync="pag"
                            :total-items="totalItems"
                            :loading="loading"
                            :rows-per-page-items="rows"
                            rows-per-page-text="Filas por pagina"
                            no-data-text="No hay datos"
                            disable-initial-sort
                            item-key="id"
                            class="tabla-compacta-col"
                    >
                        <template slot="items" slot-scope="props">
                            <tr>
                                <template v-for="h in headers">
                                    <td class="text-xs-center" v-if="h.value === 'id'">{{ props.item.id }}</td>
                                    <td class="text-xs-center" v-else-if="h.value === 'activo'">
                                        <v-btn @click="activar(props.item)" flat small dark icon
                                               :color="(props.item.activo === 1)? 'green':'red'"
                                               :loading="activando === props.item.id ">
                                            <v-icon v-text="(props.item.activo === 1)? 'check':'clear'"></v-icon>
                                        </v-btn>
                                    </td>
                                    <td class="text-xs-center" v-else-if="h.value === 'item_tipo_id'">
                                        <v-edit-dialog
                                                :return-value.sync="props.item.item_tipo_id"
                                                lazy
                                                @save="update(props.item)"
                                        > {{ (props.item.tipo)? props.item.tipo.desig : '' }}
                                            <template slot="input">
                                                <select-tipo v-model="props.item.item_tipo_id" label="Seleccione tipo"
                                                             item-value="id"></select-tipo>
                                            </template>
                                        </v-edit-dialog>
                                    </td>
                                    <td class="text-xs-center" v-else
                                        @mouseover="hover = props.item.id + '|' + h.value">
                                        <v-edit-dialog :return-value.sync="props.item[h.value]" lazy
                                                       @save="update(props.item)">
                                            <span v-if="props.item[h.value]">{{ props.item[h.value] }}</span>
                                            <v-btn icon flat small
                                                   v-if="!props.item[h.value] && hover === props.item.id + '|' + h.value">
                                                <v-icon small>edit</v-icon>
                                            </v-btn>
                                            <template slot="input">
                                                <v-text-field v-model="props.item[h.value]" label="Editar"
                                                              single-line></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                    </td>
                                </template>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import mixinItems from '../../../mixins/items'
    import selectTipo from '../../../components/TipoItemSelect'
    import {mapGetter, mapActions} from 'vuex';

    export default {
        name: "gestion",
        mixins: [mixinItems],
        components: {selectTipo},
        data() {
            return {
                search: '',
                totalItems: 0,
                loading: false,
                headers: [
                    {text: 'ID', value: 'id', align: 'center'},
                    {text: 'Activo', value: 'activo', align: 'center'},
                    {text: 'Descripción', value: 'descripcion', align: 'center'},
                    {text: 'UM', value: 'um', align: 'center'},
                    {text: 'Tipo', value: 'item_tipo_id', align: 'center'},
                    {text: 'Ancho', value: 'ancho', align: 'center'},
                    {text: 'ID Frio', value: 'micro_id_1', align: 'center'},
                    {text: 'ID Berv', value: 'micro_id_2', align: 'center'},
                    {text: 'ID Acero', value: 'micro_id_3', align: 'center'},
                ],
                items: [],
                pag: {
                    sortBy: 'id',
                    descending: true
                },
                filtro: {
                    tipo: ''
                },
                rows: [10, 20, 30, {text: 'Todo', value: -1}],
                activando: -1,
                hover: -1
            }
        },
        watch: {
            pag: {
                handler() {
                    this.getData();
                },
                deep: true,
                immediate: false
            }
        },
        mounted() {
            this.getData()
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            ...mapActions('progreso', ['progresoShow', 'progresoHide', 'progresoPorcent']),
            getData() {
                this.loading = true;
                this.pag.search = this.search;
                this.pag.filtro = this.filtro;
                this.itemIndex(this.pag, r => {
                    this.items = r.data;
                    this.totalItems = r.total;
                    this.loading = false;
                }, err => {
                    console.log(err);
                    this.loading = false;
                });
            },
            activar(item) {
                let activo = (item.activo === 1) ? 2 : 1;
                this.activando = item.id;
                this.itemActivar({id: item.id, activo: activo}, r => {
                    this.activando = -1;
                    item.activo = activo;
                }, err => {
                    this.activando = -1;
                })
            },
            update(item) {
                this.itemUpdate(item.id, item, r => {
                    this.msjShow(r);
                    this.getData()
                }, err => {
                    this.msjShow({tipo: 2, txt: 'Error al guardar'});
                })
            },
            verificaBloqueados() {
                let url = window.Laravel.urlBase + '/items/verifica-bloqueados';
                let es = new EventSource(url);
                this.progresoShow({tit: 'Procesando lista de items'});
                es.addEventListener('message', event => {
                    let data = JSON.parse(event.data);
                    if (data.prog === 'fin') {
                        es.close();
                        this.getData();
                        this.progresoHide();
                    } else {
                        this.progresoPorcent({porcent: data.prog})
                    }
                });
                es.addEventListener('error', event => {
                    if (event.readyState === EventSource.CLOSED) {
                        console.log('Event was closed');
                        console.log(EventSource);
                        this.progresoHide();
                    } else {
                        this.progresoHide();
                    }
                    console.log(event);
                }, false);
            },
            actualizaAnchos() {
                let url = window.Laravel.urlBase + '/items/actualiza-anchos';
                let es = new EventSource(url);
                this.progresoShow({tit: 'Procesando lista de items'});
                es.addEventListener('message', event => {
                    let data = JSON.parse(event.data);
                    if (data.prog === 'fin') {
                        es.close();
                        this.getData();
                        this.progresoHide();
                    } else {
                        this.progresoPorcent({porcent: data.prog})
                    }
                });
                es.addEventListener('error', event => {
                    if (event.readyState === EventSource.CLOSED) {
                        console.log('Event was closed');
                        console.log(EventSource);
                        this.progresoHide();
                    } else {
                        this.progresoHide();
                    }
                    console.log(event);
                }, false);
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/archivo/productos/gestion.vue